import React, { useState } from "react";
import { Fab, Tooltip, Box, useTheme, alpha } from "@mui/material";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import { useTranslation } from "react-i18next";
import FeedbackModal from "./FeedbackModal";

export default function FeedbackFab({ bottomOffset = 0 }) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();

  // ✅ να μη σκεπάζεται από mobile bottom nav
  const bottom = 16 + (Number(bottomOffset) || 0);

  return (
    <>
      <Box sx={{ position: "fixed", right: 16, bottom, zIndex: 1400 }}>
        <Tooltip title={t("feedback.fab_tooltip")} placement="left">
          <Fab
            onClick={() => setOpen(true)}
            variant="extended"
            sx={{
              borderRadius: 999,
              px: 2,
              fontWeight: 800,
              textTransform: "none",
              boxShadow: "0 14px 40px rgba(0,0,0,0.25)",
              background:
                theme.palette.mode === "dark"
                  ? `linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.9)}, ${alpha(
                      theme.palette.secondary.main,
                      0.8
                    )})`
                  : `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            }}
          >
            <RateReviewRoundedIcon sx={{ mr: 1 }} />
            {t("feedback.fab_label")}
          </Fab>
        </Tooltip>
      </Box>

      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
